import React from "react";
import { Switch } from "react-router-dom";
import {
  LoggedLayout,
  NonLoggedLayout,
  OnboardingLayout,
  PublicLayout,
  TwistLayout,
  TwistLayoutContainer,
  UnifiedLoginLayout
} from "./layouts";
import {
  UnifiedLogin,
  AccountRegister,
  Login,
  Home,
  HomeContact,
  Register,
  RecoverPassword,
  ResetPassword,
  Page,
  Profile,
  ProfileEdit,
  Components,
  ProjectEdit,
  ProjectIndex,
  SlideIndex,
  SlideNew,
  SlideShow,
  SlideEdit,
  QualityExport,
  QualityNew,
  QualityShow,
  QualitySuccess,
  DeliveryRequestEdit,
  DeliveryRequestShow,
  DeliveryRequestIndex,
  DeliveryRequestMap,
  DeliveryOrderNew,
  DeliveryOrderSuccessForm,
  OnboardingIndex,
  OnboardingTwistGo,
  OnboardingAccounting,
  OnboardingFreemium,
  OnboardingFailure,
  OnboardingFinished,
  OnboardingPlans,
  OnboardingPaymentConfirm
} from "../screens";


const routes = (
  <Switch>
    <LoggedLayout exact path="/home" component={Home} />
    <LoggedLayout exact path="/profile" component={Profile} />
    <LoggedLayout exact path="/profile/edit" component={ProfileEdit} />
    <LoggedLayout exact path="/slides" component={SlideIndex} />
    <LoggedLayout exact path="/slides/new" component={SlideNew} />
    <LoggedLayout exact path="/slides/:id" component={SlideShow} />
    <LoggedLayout exact path="/slides/:id/edit" component={SlideEdit} />
    <NonLoggedLayout exact path="/login" component={Login} />
    <NonLoggedLayout exact path="/register" component={Register} />
    <NonLoggedLayout exact path="/reset_password" component={ResetPassword} />
    <NonLoggedLayout
      exact
      path="/recover_password"
      component={RecoverPassword}
    />
    {/* Paid onboarding used to also be the root flow; root is now the unified
        OTP login (see below). /manual_onboarding keeps the legacy no-payment
        signup, used only by the support team. */}
    <OnboardingLayout exact path="/onboarding" component={OnboardingIndex} />
    <OnboardingLayout exact path="/manual_onboarding" component={OnboardingIndex} />
    <OnboardingLayout exact path="/twistgo" component={OnboardingTwistGo} />
    <OnboardingLayout exact path="/accounting" component={OnboardingAccounting} />
    <OnboardingLayout exact path="/freemium" component={OnboardingFreemium} />
    <OnboardingLayout exact path="/account_register" component={AccountRegister} />
    <OnboardingLayout exact path="/onboarding/plans" component={OnboardingPlans} />
    <OnboardingLayout exact path="/onboarding/payment/confirm" component={OnboardingPaymentConfirm} />
    <OnboardingLayout exact path="/success" component={OnboardingFinished} />
    <OnboardingLayout exact path="/failure" component={OnboardingFailure} />
    <TwistLayout exact path="/projects" component={ProjectIndex} />
    <TwistLayoutContainer
      exact
      path="/project/:id/quality"
      component={QualityNew}
    />
    <TwistLayout
      exact
      path="/delivery_requests/:id/edit"
      component={DeliveryRequestEdit}
    />
    <TwistLayout
      exact
      path="/delivery_requests/:id"
      component={DeliveryRequestShow}
    />
    <TwistLayout
      exact
      path="/delivery_requests_list"
      component={DeliveryRequestIndex}
    />
    <TwistLayout
      exact
      path="/map/delivery_requests"
      component={DeliveryRequestMap}
    />
    <TwistLayout
      exact
      path="/projects/:projectId/delivery_order_form/:deliveryOrderId"
      component={DeliveryOrderNew}
    />
    <PublicLayout
      exact
      path="/success_delivery_order_form"
      component={DeliveryOrderSuccessForm}
    />

    <TwistLayout exact path="/project/:id/edit" component={ProjectEdit} />
    <TwistLayout exact path="/qualities/export" component={QualityExport} />
    <PublicLayout exact path="/qualities/success" component={QualitySuccess} />
    <TwistLayoutContainer exact path="/qualities/:id" component={QualityShow} />
    {/* Unified OTP login + tenant picker (email -> code -> choose company),
        talks directly to the parrotfy Core API - see services/coreApi.js. */}
    <UnifiedLoginLayout exact path="/" component={UnifiedLogin} />
    <PublicLayout exact path="/contact" component={HomeContact} />
    <PublicLayout exact path="/components" component={Components} />
    <PublicLayout path="/:page" component={Page} />
  </Switch>
);

export default routes;
